import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import PropTypes from 'prop-types';

const DateTimePickerField = ({ onChange, value }) => {
  const [startDate, setStartDate] = useState(value ? new Date(value) : null);

  useEffect(() => {
    setStartDate(value ? new Date(value) : null);
  }, [value]);

  const handleChange = (date) => {
    setStartDate(date);
    onChange(date);
  };

  return (
    <div className="date-picker">
      <DatePicker
        timeFormat="hh:mm aa"  // 12-hour format with AM/PM
        className="form__form-group-datepicker"
        selected={startDate}
        onChange={handleChange}
        showTimeSelect
        dateFormat="dd/MM/yyyy hh:mm aa"  // Date format: day/month/year with 12-hour time
        dropDownMode="select"
        withPortal={isMobileOnly}
        portalId="root"
        popperClassName="date-picker"
      />
    </div>
  );
};

DateTimePickerField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

const renderDateTimePickerField = ({ input }) => <DateTimePickerField {...input} />;

renderDateTimePickerField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }).isRequired,
};

export default renderDateTimePickerField;
